import notification from "./notification";

const appsModule = {
  namespaced: true,
  modules: { notification },
};

export default appsModule;
